import React from "react"
import Badge from "../common/Badge.jsx"
import { getOrderStatusBadgeStyle } from "../utils/orderStatusBadge.js"

/**
 * @param {{
 *   status: string | null | undefined,
 *   label?: any,
 *   className?: string,
 *   title?: string,
 * }} props
 */
export default function OrderStatusBadge({
    status,
    label = undefined,
    className = "",
    title = undefined,
}) {
    return (
        <Badge
            className={className}
            title={title ?? (typeof (label ?? status) === "string" ? (label ?? status) : undefined)}
            style={getOrderStatusBadgeStyle(status)}
        >
            <span className="text-truncate">{label ?? status ?? "—"}</span>
        </Badge>
    )
}

